module.exports = __webpack_public_path__ + "static/aisle-mgmt-logo-ad30ab5267a440e8bbac07f652bbbc0d.png";